import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { options: Object }
  connect() {
    if (this.hasOptionsValue) {
      this.modal = new bootstrap.Modal(this.element, this.optionsValue)
    } else {
      this.modal = new bootstrap.Modal(this.element, {})
    }
    this.modal.show()
    this.element.addEventListener('hidden.bs.modal', () => {
      setTimeout(() => {
        this.element.remove()
      }, 500);
    });
  }
}
